import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

#partiu-gp-header .header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

#partiu-gp-header a {
  text-decoration: none;
}

#partiu-gp-header .header-logo img {
  height: 20px;
}

#partiu-gp-header .header-nav {
  display: none;
}

#partiu-gp-header .header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

#partiu-gp-header .header-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid #ec0000;
  background: #fff;
  color: #ec0000;
  font-family: 'SantanderText';
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
  transition: background-color 350ms linear;
}

#partiu-gp-header .header-cta:hover {
  background-color: #ffeaea;
}

#partiu-gp-header .header-cta-icon {
  display: none;
}

#partiu-gp-header .header-menu-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ec0000;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 350ms linear;
}

#partiu-gp-header .header-menu-btn:hover {
  background-color: #f14c4c;
}

#partiu-gp-header .header-menu-btn span {
  display: block;
  width: 18px;
  height: 2px;
  background: #fff;
}

#partiu-gp-header .header-mobile-nav {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: calc(100vh - 100%);
  overflow-y: auto;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  flex-direction: column;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

#partiu-gp-header .header-mobile-nav.opened {
  display: flex;
}

#partiu-gp-header .header-mobile-nav a {
  padding: 16px 24px;
  color: #222;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 400;
  border-bottom: 1px solid #f0f0f0;
}

#partiu-gp-header .header-mobile-nav a.active {
  color: #ec0000;
}


@media (min-width: 380px) {
  #partiu-gp-header .header-logo img {
    height: 30px;
  }
}


@media (min-width: 992px) {
  #partiu-gp-header .header-inner {
    height: 80px;
  }

  #partiu-gp-header .header-nav {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  #partiu-gp-header .header-nav a {
    color: #222;
    font-family: 'SantanderText';
    font-size: 16px;
    font-weight: 400;
    white-space: nowrap;
  }

  #partiu-gp-header .header-nav a:hover,
  #partiu-gp-header .header-nav a.active {
    color: #ec0000;
  }

  #partiu-gp-header .header-cta {
    height: 48px;
    padding: 12px 16px;
    border-radius: 24px;
    background: #ec0000;
    border-color: #ec0000;
    color: #fff;
    font-size: 16px;
  }

  #partiu-gp-header .header-cta:hover {
    background-color: #f14c4c;
  }

  #partiu-gp-header .header-cta-icon {
    display: block;
    width: 20px;
    height: 20px;
  }

  #partiu-gp-header .header-menu-btn {
    display: none;
  }

  #partiu-gp-header .header-mobile-nav {
    display: none !important;
  }
}

@media (min-width: 1100px) {
  #partiu-gp-header .header-nav {
    gap: 24px;
  }
}
`;

export default styles;